/* eslint-disable */
export const regexContent = (data, language) => {
  const registration_numbers_keys = data.companyInfo.company_registration_number.flatMap((data) => [
    data.key,
    `${data.key}_desc`,
  ]);
  const registration_numbers_data = data.companyInfo.company_registration_number.flatMap((data) => [
    data.translations.find((translation) => translation.languages_code === language).number,
    data.translations.find((translation) => translation.languages_code === language).description,
  ]);
  const registration_numbers = {};
  registration_numbers_keys.forEach(
    (key, data) => (registration_numbers[key] = registration_numbers_data[data])
  );

  const companyInfo = {
    ...data.staticPage,
    ...data.companyInfo,
    ...registration_numbers,
    board: data.companyInfo.board
      .map((item) => item.employee_profile_id)
      .map((profile) => `${profile.name} ${profile.surname}`)
      .join(", "),
  };

  const companyInfoKeys = Object.keys(companyInfo).map((item) => `{${item}}`);

  const newRegex = new RegExp(companyInfoKeys.map((item) => `\\$${item}`).join("|"), "gi");

  Object.keys(data.staticPage).forEach((key) => {
    if (typeof data.staticPage[key] === "string") {
      data.staticPage[key] = data.staticPage[key].replace(
        newRegex,
        (matched) => companyInfo[matched.substring(2, matched.length - 1)]
      );
    }
  });

  return data.staticPage;
};



// WEBPACK FOOTER //
// ./src/lib/regexContent.js